
export const DOMAIN = "https://api.zayads.ru";
export const MAX_IMPORTING_EPISODES_COUNT = 10;
export const NOTIFICATIONS_LIFETIME = 5000;
